<template>
  <div>
  <v-row>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-4"
      v-model="editedItem.systemId" label="System ID" readonly tabindex="-1"/>
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-4"
      v-model="editedItem.propertyOrParcelId" label="Property ID" readonly tabindex="-1"/>
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-4"
      v-model="editedItem.taxId" label="Tax ID" readonly tabindex="-1"/>
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model.number="editedItem.saleYear" label="Sale Year"/>
    </v-col>
    <v-col cols="8" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.ownerName" label="Name on Tax Record" readonly tabindex="-1"/>
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.situsAddress" label="Situs Address" readonly tabindex="-1"/>
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.addition" label="Addition" readonly tabindex="-1"/>
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      :value="amountFormat(editedItem.assessedValue)" label="Assessed Value" readonly tabindex="-1"/>
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <ClarionDateControl class="input-text-size mt-n4" :isToggle="false"
      v-model="editedItem.commissionerPubDateOne" label="Publication Date 1" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <ClarionDateControl class="input-text-size mt-n4" :isToggle="false"
      v-model="editedItem.commissionerDateOfSale" label="Sale Date" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <ClarionDateControl class="input-text-size mt-n4" :isToggle="false"
      v-model="editedItem.commissionerDateOfMeeting" label="Commissioner Meeting Date" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <ClarionDateControl class="input-text-size mt-n4" :isToggle="false"
      v-model="editedItem.commissionerPubDateTwo" label="Publication Date 2" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size pa-0 mt-n2" label="Sale Time"
      v-model="editedItem.commissionerTimeOfSale" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size pa-0 mt-n2" label="Sale Fees"
      v-model="editedItem.commissionerSaleFees" @blur="roundAmount('commissionerSaleFees')"
      @focus="amountToNum('commissionerSaleFees'), $event.target.select()" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <ClarionDateControl class="input-text-size mt-n4" :isToggle="false"
      v-model="editedItem.commissionerPubDateThree" label="Publication Date 3" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0"></v-col>
    <v-col cols="4" class="pt-0 pb-0 mt-n4">
      <v-checkbox class="input-text-size tax-roll-criteria-unpaids-checkbox"
        v-model="editedItem.isItSold" label="Sold" />
    </v-col>
  </v-row>
  <v-textarea class="input-text-size pt-0 pb-0 mb-n5" v-model="editedItem.legalDesc"
  outlined rows="1" label="Legal Description"/>
  <v-row>
    <v-col cols="8" class="pt-0 pb-0">
      <CRUDList
        ref="crudList"
        :canAdd="true"
        :headers="headers"
        :displayTopPagination="false"
        :canEdit="true"
        :canSave="true"
        :showDate="true"
        :showDialog="true"
        :canDelete="false"
        :canDeleteInDialog="true"
        :disablePagination="true"
        :hideDefaultFooter="true"
        :enableFixedHeaders="true"
        :baseCrudKey="baseCrudKeyForBidderDetails"
        :defaultSortBy="defaultSortBy"
        dialogDynamicWidth="40vw"
        dialogHeaderName="Bid Detail"
        tableWrapperDynamicClassname="ma-0 pa-0 pb-0 taxroll-table-wrapper"
        tableDynamicClassname="taxroll-custom-table"
        tableDynamicHeight="130"
        @upsertItem="upsertTransaction"
        @deleteItem="deleteTransaction">
      <template v-slot:[`editedItem`]="{ }">
        <v-row>
          <v-col cols="6" class="pt-0 pb-0">
            <ClarionDateControl class="input-text-size ma-0 pa-0" :isToggle="false"
            v-model="editedItemForBidDetails.bidDate" label="Date" />
          </v-col>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field class="input-text-size ma-0 pa-0 mt-4" type="number"
            v-model.number="editedItemForBidDetails.regNumber" label="Reg #" @blur="updateRegNumber" />
          </v-col>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
            v-model="editedItemForBidDetails.bidderName" label="Bidder Name" />
          </v-col>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
            v-model="editedItemForBidDetails.bidAmount" label="Bid Amount"
            @blur="roundAmountBid" @focus="amountToNumBid(), $event.target.select()" />
          </v-col>
        </v-row>
      </template>
      </CRUDList>
    </v-col>
    <!-- d-flex flex-column, not a breakpoint: the three reports stack one per line and share a
         width at every viewport size, so the group always reads as one block. -->
    <v-col cols="4" class="pt-0 pb-0 d-flex flex-column">
      <v-btn class="input-text-size mb-2" text color="blue darken-1"
        :disabled="isPrinting" @click="printCountyDeed">Print County Deed</v-btn>
      <v-btn class="input-text-size mb-2" text color="blue darken-1"
        :disabled="isPrinting" @click="printTranscript">Print Transcript</v-btn>
      <v-btn class="input-text-size" text color="blue darken-1"
        :disabled="isPrinting" @click="printNotice">Print Notice</v-btn>
    </v-col>
  </v-row>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import { amountFormat, amountToNumber } from '../../../../../util/shared/vue-global';
import { commissionerBidderMainHeader, commissionersSaleSaveFields } from '../../deliquentUtils/deliquent.utils';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import ClarionDateControl from '../../../../common/ClarionDateControl.vue';
import { generateQueryString } from '../../../../common/base/report/report-util';
import { clients } from '../../../../../util/clients';

const { backendRest } = clients.direct;
export default {
  name: 'CommissionersPropertyListDialog',
  props: {
    baseCrudKey: {
      type: String,
      default: 'CommissionersPropertyListDialog',
    },
    baseCrudKeyForBidderDetails: {
      type: String,
      default: 'CommissionersPropertyListForBidder',
    },
    saleYear: {
      type: Number,
      default: null,
    },
    baseCrudKeyForBidderRegistration: {
      type: String,
      default: 'BidderRegistrationBaseCrudKey',
    },
  },
  components: {
    CRUDList,
    ClarionDateControl,
  },
  data() {
    return {
      checkbox: true,
      // each print now writes the record first, so a double click would save and open the report
      // twice - hold the buttons until the current one has opened
      isPrinting: false,
      baseCrudKeyAdditional: 'AdditionalNameAddressesList',
      baseCrudKeyAdditionalTable: 'AdditionalNameAddressesTableList',
      baseCrudKeyAdditionalDialog: 'AdditionalNameAddressesDialog',
      baseCrudKeyForAddDetail: 'baseCrudKeyForAddDetail',
      baseCrudKeyForTaxFees: 'baseCrudKeyForTaxFees',
      selectedRowItem: {},
      addDetail: {
        taxYear: null,
        taxId: null,
      },
      headers: commissionerBidderMainHeader,
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'criteria',
      'index',
      'isVisible',
    ]),
    ...mapState({
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKeyAdditional);
      },
      set(value) {
        this.setCriteria([this.baseCrudKeyAdditional, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    editedItemForBidDetails: {
      get() {
        return this.item(this.baseCrudKeyForBidderDetails);
      },
      set(value) {
        this.setItem([this.baseCrudKeyForBidderDetails, value]);
      },
    },
    getBidderRegistrationItems() {
      return this.items(this.baseCrudKeyForBidderRegistration) || [];
    },
    defaultSortBy() {
      return [
        {
          column: '_id',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    amountFormat,
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setHighlightedId']),
    ...mapActions(['custumColrFlashMsg', 'flashSuccess', 'flashWarn']),
    ...mapActions(['reAuth']),
    ...mapActions('tax/commissionersSale', [
      'loadCommissionersSaleDeedGroup',
      'upsertCommissionersSaleSelectedFields',
    ]),
    // All three reports are built from the stored record, so anything typed but not saved used to
    // print as the old value with no warning. Save first and hand back the _id the report should
    // run against; null means nothing was written and the caller must not print - a report of
    // stale data right after a failed save is worse than no report at all.
    async saveBeforePrint() {
      if (!this.editedItem._id) {
        this.flashWarn('Save this record before printing.');
        return null;
      }
      const itemToSent = commissionersSaleSaveFields(this.editedItem);
      const res = await this.upsertCommissionersSaleSelectedFields({ itemToSent });
      // the action has already flashed what went wrong on both the 201 and the thrown case
      if (!res || res.statusCode !== 200) return null;
      // keep the grid behind the dialog in step with what was just written, holding this record
      this.$emit('loadCRUDList', itemToSent._id);
      return itemToSent._id;
    },
    // With Commissioner Deeds set to Print Combined, one deed can convey every property this
    // bidder won at this sale. Confirm first so a multi-tract deed is never a surprise. A failed
    // lookup deliberately falls through and prints - the confirmation is a courtesy, not a gate.
    async confirmCombinedDeed() {
      if (!this.editedItem._id) return true;
      const deedGroup = await this.loadCommissionersSaleDeedGroup({ id: this.editedItem._id });
      const accounts = (deedGroup && deedGroup.taxIds) || [];
      if (accounts.length < 2) return true;
      const bidder = deedGroup.bidderName ? `${deedGroup.bidderName} ` : 'This bidder ';
      return window.confirm(`${bidder}won ${accounts.length} properties in this sale.\n\n`
        + `Printing ONE combined deed for accounts ${accounts.join(', ')}, `
        + `for a combined ${amountFormat(deedGroup.combinedBidAmount)}.\n\nContinue?`);
    },
    // Opens report `path` for the record as it now stands on screen. Every caller goes through
    // here so no report can skip the save. `beforeOpen` runs after the save and can still call it
    // off - the combined-deed confirmation has to read the record as saved, since the accounts it
    // lists are grouped on isItSold, saleYear and commissionerDateOfSale, all editable here.
    async openReport(path, beforeOpen) {
      if (this.isPrinting) return;
      this.isPrinting = true;
      try {
        const id = await this.saveBeforePrint();
        if (!id) return;
        if (beforeOpen && !await beforeOpen()) return;
        const { jwt } = await this.reAuth();
        const params = [
          `token=${jwt}`,
          `id=${id}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        window.open(`${backendRest.defaults.baseURL}${path}${queryString}`, '_blank');
      } finally {
        this.isPrinting = false;
      }
    },
    printCountyDeed() {
      return this.openReport('/commissionersSaleTranscript/deed', this.confirmCombinedDeed);
    },
    printTranscript() {
      return this.openReport('/commissionersSaleTranscript/transcript');
    },
    printNotice() {
      return this.openReport('/juneResale/commissioner-notice-txt');
    },
    upsertTransaction(item) {
      this.$emit('upsertTransaction', item);
    },
    deleteTransaction(item) {
      this.setIsVisible([this.baseCrudKeyForBidderDetails, false]);
      this.$emit('deleteTransaction', item);
    },
    updateRegNumber() {
      const bidderRegistrationItems = this.getBidderRegistrationItems || [];
      if (!this.editedItemForBidDetails.regNumber) return;
      const bidderRegistrationItem = bidderRegistrationItems
        .find((item) => amountToNumber(item.regNumber)
         === amountToNumber(this.editedItemForBidDetails.regNumber));
      let bidderName = '';
      if (bidderRegistrationItem) {
        bidderName = bidderRegistrationItem.bidderName || '';
      } else {
        this.custumColrFlashMsg({
          msg: 'Registration number not found. Please check the Bidder registration.',
        });
      }
      this.setItem([
        this.baseCrudKeyForBidderDetails,
        { ...this.editedItemForBidDetails, bidderName },
      ]);
    },
    roundAmount(val) {
      const formatedAmt = amountFormat(amountToNumber(this.editedItem[val]));
      this.editedItem[val] = formatedAmt;
    },
    amountToNum(val) {
      const formatedAmt = amountToNumber(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
    },
    roundAmountBid() {
      this.setItem([
        this.baseCrudKeyForBidderDetails,
        { ...this.editedItemForBidDetails, bidAmount: amountFormat(amountToNumber(this.editedItemForBidDetails.bidAmount)) },
      ]);
    },
    amountToNumBid() {
      this.setItem([
        this.baseCrudKeyForBidderDetails,
        { ...this.editedItemForBidDetails, bidAmount: amountToNumber(this.editedItemForBidDetails.bidAmount) },
      ]);
    },
  },
};
</script>
